import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useCustomerStore } from '@/my/modules/account/stores/customer.store'
import { setCookie, getCookie, deleteCookie } from '@/services/cookies'

const SESSION_COOKIE_NAME = 'session'

export const useAuthStore = defineStore(
  'auth',
  () => {
    const token = ref('')
    const loaded = ref(false)
    const customerStore = useCustomerStore()
    const isAuthenticated = ref(false)

    function store(newToken: string) {
      token.value = newToken
      setCookie(SESSION_COOKIE_NAME, token.value, 365)
    }

    function loadTokenFromCookie() {
      const existingToken = getCookie(SESSION_COOKIE_NAME)
      token.value = existingToken
      loaded.value = true
    }

    function getToken(): string {
      if (!loaded.value || token.value.toString().length == 0) loadTokenFromCookie()
      return token.value
    }

    function clear() {
      token.value = ''
      loaded.value = false
      customerStore.clear()
      deleteCookie(SESSION_COOKIE_NAME)
    }

    return {
      token,
      store,
      loaded,
      getToken,
      clear,
      loadTokenFromCookie,
      isAuthenticated
    }
  },
  {
    persist: {
      key: `my-session-${import.meta.env.VITE_APP_ENV}`,
      pick: ['isAuthenticated']
    }
  }
)
